import {Controller} from "stimulus"

export default class extends Controller {
  connect() {
      if ($("#web_applicant_waiver_requested").is(':checked') == true) {
          $( "#waiversection" ).show();
      } else {
          $( "#waiversection" ).hide();
      };
  }

    yeswaiver() {
       if (event.target.checked) {
         $( "#waiversection" ).show();
        } else {
           $( "#waiversection" ).hide();

       }
    }
  }
